module.exports = __webpack_public_path__ + "dae1d0092fb35871b9f31cac3780d749.glb";